import taprohm from "@/assets/angkor-wat-sunrise-tour.jpg";
import bayon from "@/assets/private-tour-angkor-cambodia.jpg";
import banteay from "@/assets/tour-koh-rong-sunset-hero.jpg";

const tours = [
  {
    n: "01",
    img: taprohm,
    title: "Siem Reap 2 Day Tour Package Price & Itinerary",
    sub: "Ta Prohm & the Lost Roots",
    days: "2 Days",
    price: "From $85",
    body: "​",
  },
  {
    n: "02",
    img: bayon,
    title: "Siem Reap Tour, Angkor Wat Tour, 4 Day Itinerary",
    sub: "Angkor  Kulen BanteaySrei  Kampong Khleang",
    days: "4 Days",
    price: "From $415",
    body: "​",
  },
  {
    n: "03",
    img: banteay,
    title: "Cambodia 15 Day Tour Package Price & Itinerary",
    sub: "From Temple to Coast",
    days: "15 Days",
    price: "From $315",
    body: "​",
  },
];

const Tours = () => {
  return (
    <section id="tours" className="bg-background py-28 md:py-40">
      <div className="container">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-20">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-5">— Signature Expeditions</p>
            <h2 className="font-display text-5xl md:text-7xl max-w-2xl leading-[1] text-balance">
              Three journeys, <em className="font-light">one</em> ancient kingdom.
            </h2>
          </div>
          <p className="max-w-sm text-muted-foreground font-light">
            Every itinerary is privately guided, capped at eight travellers, and built around the rhythm of light, monks, and monsoon.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-x-8 gap-y-16">
          {tours.map((t, i) => (
            <article key={t.n} className="group" style={{ animationDelay: `${i * 120}ms` }}>
              <div className="relative overflow-hidden mb-6 aspect-[4/5] bg-secondary shadow-soft">
                <img
                  src={t.img}
                  alt={t.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                />
                <span className="absolute top-5 left-5 text-background font-display text-3xl">{t.n}</span>
                <span className="absolute bottom-5 right-5 text-[10px] uppercase tracking-[0.3em] text-background bg-foreground/40 backdrop-blur px-3 py-1.5">
                  {t.days}
                </span>
              </div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{t.sub}</p>
              <h3 className="font-display text-3xl mb-3 md:text-xl">{t.title}</h3>
              <p className="text-muted-foreground font-light leading-relaxed mb-5 text-lg">{t.body}</p>
              <div className="flex items-center justify-between border-t border-border pt-4">
                <span className="text-sm">{t.price}</span>
                <a href="#contact" className="text-[11px] uppercase tracking-[0.3em] text-foreground hover:text-primary transition-colors">
                  Inquire →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Tours;
